<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="flex flex-col h-full">

    <!-- Top cards: Ship To + Carrier Info -->
    <div class="grid grid-cols-12 gap-4 p-4 shrink-0">

      <!-- Ship To Address Card -->
      <div class="col-span-4 qb-detail-card qb-primary-tint p-4">
        <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Ship To</div>
        <div class="qb-stacked-field">
          <div class="value leading-relaxed whitespace-pre-line">{{addressText}}</div>
        </div>
      </div>

      <!-- Carrier Info Card -->
      <div class="col-span-8 qb-detail-card qb-primary-tint p-4">
        <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Carrier</div>
        <div class="grid grid-cols-12 gap-3">
          <uni-field label="Carrier" class="col-span-3">
            <p-dropdown [options]="carriers" [(ngModel)]="selectedCarrier" optionLabel="name"
              (ngModelChange)="onCarrierChange($event)" placeholder="Select Carrier" class="w-full" />
          </uni-field>
          <uni-field label="Account Name (from JO)" class="col-span-3">
            <input type="text" pInputText [(ngModel)]="jo.carrierAccountName" title="Account Name" class="w-full" />
          </uni-field>
          <uni-field label="Account Number" class="col-span-3">
            <input type="text" pInputText [(ngModel)]="jo.carrierAccountNumber" title="Account Number" class="w-full" />
          </uni-field>
          <uni-field label="Postal Code" class="col-span-3">
            <input type="text" pInputText [(ngModel)]="jo.carrierAccountPostalCode" title="Postal Code" class="w-full" />
          </uni-field>
        </div>
      </div>

    </div>

    <!-- Box Weights Section -->
    <div class="px-4 shrink-0">
      <div class="qb-child-actions items-center gap-3">
        <span class="font-semibold text-base uppercase tracking-wide">Box Weights</span>
        <uni-field label="">
          <p-dropdown [options]="uoms" [(ngModel)]="uomId" (ngModelChange)="onUomChange($event)" optionValue="id"
            optionLabel="name" class="small-dropdown" placeholder="Select UOM" />
        </uni-field>
        <button [disabled]="!canAddBox()" (click)="addBox()" pButton type="button"
          class="p-button-raised p-button-sm" icon="pi pi-plus">
          <span>Add Box</span>
        </button>
        <button [disabled]="!canReadScale()" (click)="readScale()" pButton type="button"
          class="p-button-raised p-button-sm" icon="pi pi-sliders-h">
          <span>Read Scale</span>
        </button>
        <span *ngIf="scaleService.isConnected" class="text-sm text-green-500 flex items-center gap-1">
          <i class="pi pi-circle-fill text-[0.5rem]"></i>
          {{scaleService.deviceName}}
        </span>
      </div>
      <app-ag-grid style="height: 250px" [gridOptions]="boxWeightGridOptions" [rowData]="boxes" [hasFooter]="false">
      </app-ag-grid>
    </div>

    <!-- Rates Section -->
    <div class="flex flex-col flex-1 min-h-0 px-4 mt-3">
      <div class="qb-child-actions items-center gap-3">
        <span class="font-semibold text-base uppercase tracking-wide">Rates</span>
        <button [disabled]="!canGetRates()" (click)="lookupRates()" pButton type="button"
          class="p-button-raised p-button-sm" icon="pi pi-search">
          <span>Get Rates</span>
        </button>
      </div>
      <app-ag-grid class="flex-1 min-h-0" [gridOptions]="rateGridOptions" [rowData]="rates" [hasFooter]="false">
      </app-ag-grid>
    </div>

    <!-- Selected Service -->
    <div class="grid grid-cols-12 gap-3 p-4 shrink-0">
      <uni-field label="Selected Service" class="col-span-6">
        <input [value]="selectedService?.name" disabled pInputText class="w-full" />
      </uni-field>
      <uni-field label="Service Code (ShipEngine)" class="col-span-6">
        <input [value]="selectedService?.code" disabled pInputText class="w-full" />
      </uni-field>
    </div>

  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button [disabled]="!canClickOk()" (click)="ok()" pButton type="button" class="p-button-raised" icon="pi pi-check">
      <span>Ok</span>
    </button>
    <button (click)="cancel()" pButton type="button" class="p-button-raised" icon="pi pi-times">
      <span>Cancel</span>
    </button>
  </div>
</ng-template>
